<template>
  <div class="page page-company">
    <div class="left-menu">
      <div class="smooth-shadow menu-list">
        <!-- <div class="user-my">
                    <img src="http://static.unicornselected.com/b68bb010-0335-11eb-91c5-d550a48abe82.png" alt="">
                    <div class="phone">18801971372</div>
        </div>-->

        <div>
          <a class="waves-effect menu-item" :class="menuIndex == -1 ? 'active' : ''" @click.stop="changeMenuIndex(-1)">
            {{'所有公司'|language}}
            <i class="material-icons">done</i>
          </a>
          <a class="waves-effect menu-item" :class="menuIndex == 0 ? 'active' : ''" @click.stop="changeMenuIndex(0)">
            {{'可交易'|language}}
            <i class="material-icons">done</i>
          </a>
          <a class="waves-effect menu-item" :class="menuIndex == 1 ? 'active' : ''" @click.stop="changeMenuIndex(1)">
            {{'我的收藏'|language}}
            <i class="material-icons">done</i>
          </a>
          <a class="waves-effect menu-item" :class="menuIndex == 2 ? 'active' : ''" @click.stop="toMy">
            {{'我的需求'|language}}
            <i class="material-icons">done</i>
          </a>
        </div>
      </div>

      <div class="smooth-shadow sort menu-list">
        <a class="waves-effect menu-item" :class="sortIndex == 0 ? 'active' : ''" @click.stop="changeSortIndex(0)">
          {{'按热度'|language}}
          <i class="material-icons">done</i>
        </a>
        <a class="waves-effect menu-item" :class="sortIndex == 1 ? 'active' : ''" @click.stop="changeSortIndex(1)">
          {{'按市值降序'|language}}
          <i class="material-icons">done</i>
        </a>
        <a class="waves-effect menu-item" :class="sortIndex == 2 ? 'active' : ''" @click.stop="changeSortIndex(2)">
          {{'按市值升序'|language}}
          <i class="material-icons">done</i>
        </a>
        <a class="waves-effect menu-item" :class="sortIndex == 3 ? 'active' : ''" @click.stop="openTagsDialog">
          {{'行业筛选'|language}} <span v-if="companyTagsNameMulti.length">:&nbsp;</span>
          <div class='companyTagSpan'>
            <span v-for="(item,index) in companyTagsNameMulti" :key="item.id">
              {{en? item.en:item.ch }}
            </span>
          </div>
          <i class="material-icons">done</i>
        </a>
        <a class=" waves-effect menu-item" :class="sortIndex == 4 ? 'active' : ''" @click.stop="openBusinessDialog">
          {{'币种'|language}}: {{translateLang(businessTypeLabel)}}
          <img v-if='sortIndex != 4' style='width:15px' src="http://static.unicornselected.com/80435250-6995-11e9-935e-9582d7d12837.png" alt="">
          <img v-else style='width:15px' src="http://static.unicornselected.com/815cb190-6995-11e9-935e-9582d7d12837.png" alt="">
          <i class="material-icons">done</i>
        </a>

      </div>
      <div class='business-type-list smooth-shadow' v-if='sortIndex ==4&&businessFlag'>
        <div @click.stop="selectBusinessType(item)" class='business-type-box' v-for="item in businessTypeObjs" :key="item.id">
          {{ item.label }}
        </div>
      </div>

    </div>
    <div class="right-content">
      <div class="way smooth-shadow hide-on-med-and-down">
        <i class="iconfont icon-jiugongge1" :class="!showStyle ? 'check1' : ''" @click.stop="changeShowStyle(false)"></i>
        <i class="iconfont icon-menu2" :class="showStyle ? 'check1' : ''" @click.stop="changeShowStyle(true)"></i>
      </div>

      <template>
        <a v-for="item in data" :key="item._id" class="hover-xiaomi company smooth-shadow grid-item" @click.stop="hrefShowLogin" :href="hrefOrLogin('/main/detail?id=' + item._id)" :target="userInstance.user ? '_blank' : ''" :class="!showStyle ? '' : 'line-item'">
          <img src="http://static.unicornselected.com/b6cf21b0-0335-11eb-91c5-d550a48abe82.png" v-if="item.hot" class="hot">
          <div class="content">
            <img :src="item.logo">
            <div class="name">{{item.projectName}}</div>

            <div class="guzhi">
              {{'估值'|language}}：
              <span v-if="item.valueType == 1">¥{{item.valuePrice | w2e}}</span>
              <span v-if="item.valueType == 2">${{item.valuePrice | w2e}}</span>
            </div>

            <a class="btn-floating btn waves-effect waves-light red" @click.stop.prevent="collectAction(item)" :class="!item.collect ? 'wait-collect' : ''">
              <i class="material-icons addIcon" v-if="!item.collect">add</i>
              <i class="material-icons" v-else>done</i>
            </a>
          </div>
          <div class="txt">{{item.companyDesp}}</div>
          <div class="kjy">
            <template v-if="item.availableAmounts">
              {{'可交易'|language}}
              <template v-if='!en'>
                <span>>&nbsp;{{item.businessType | value-type-businessType}}{{item.availableAmounts}}万</span>
              </template>
              <template v-else>
                ><span>&nbsp;&nbsp;{{item.businessType | value-type-businessType}}{{item.availableAmounts |w2e}}</span>
              </template>
            </template>&nbsp;
          </div>
        </a>
      </template>

      <div class="clear"></div>

      <div class="loading" v-if="isLoading">
        <i class="material-icons">cached</i>
      </div>
      <!-- <paginate ref="page" :page="pages" @change-page="fetchData" /> -->
    </div>

    <available ref='available' :tags='tags' @company-tag="selectCompanyTagHandler" :cleartag.sync='tags' @close-tags='closeTags' />
    <div class="clear"></div>
  </div>
</template>

<script>
import { HttpClient } from '../util/http.js';
import { setScrollTop, getScrollTop } from '../util/jq.js';
import { defaultbus } from '../util/bus.js';
import { userInstance } from '../util/user.js';
import Available from '../components/dialog/available';
import { languageTranslation } from '../util/language';

// import Paginate from "../components/Paginate";

export default {
    data() {
        return {
            data: [],
            pageNum: 0,
            pageSize: 12,
            totalData: 0,
            showStyle: localStorage.djhShowStyle === '1',
            menuIndex: -1,
            sortIndex: 0,
            kw: this.$route.query.kw || '',
            scrollEvent: null,
            isLoading: false,
            userInstance,
            showMyTrade: false,
            businessTypeLabel: '全部',
            businessTypeObjs: [],
            businessFlag: false,
            tags: [],
            tagMap: [],
            selectedTagIdList: new Set(),
            companyTagIdMulti: [],
            companyTagsNameMulti: [],
        };
    },
    components: {
        // Paginate
        Available,
    },

    computed: {
        // pages() {
        //     return parseInt((this.totalData + 8) / this.pageSize);
        // }
    },
    mounted() {},
    async created() {
        if (this.$route.query.menuIndex) {
            this.menuIndex = parseInt(this.$route.query.menuIndex);
        }

        defaultbus.$on('search', kw => {
            this.kw = kw;
            this.fetchData();
        });

        this.fetchData();
        this.scrollEvent = () => {
            if (
                !this.isLoading &&
                getScrollTop() + window.innerHeight + 100 >=
                    document.body.scrollHeight
            ) {
                // 下一页
                this.pageNum += 1;
                this.fetchData();
            }
        };
        window.addEventListener('scroll', this.scrollEvent);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollEvent);
    },

    methods: {
        changeShowStyle(style) {
            this.showStyle = style;
            localStorage.djhShowStyle = Number(style);
        },

        changeSortIndex(i) {
            this.sortIndex = i;
            this.pageNum = 0;
            this.fetchData();
        },
        changeMenuIndex(i) {
            this.menuIndex = i;
            this.pageNum = 0;
            this.fetchData();
        },

        selectBusinessType(item) {
            this.businessTypeLabel = item.label;
            this.businessTypeIndex = item.value;
            this.fetchData();
            this.businessFlag = false;
        },
        selectCompanyTagHandler(data) {
            console.log('====data====');
            console.log(data);
            console.log('=========');
            this.companyTagIdMulti = data.map(it => it[0]);
            this.companyTagsNameMulti = data.map(it => it[1]);
            this.fetchData();
        },
        closeTags() {
            this.tagMap = [];
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        },
        async openTagsDialog() {
            this.tags = this.tags.length
                ? this.tags
                : (await HttpClient.post('/restful', {
                      model: 'CompanyTag',
                  })).result;
            this.tagFlag = true;
            this.$refs.available.show = true;
            this.$refs.available.tags = this.tags.map(languageTranslation);
            document.body.style.height = '100vh';
            document.body.style.overflow = 'hidden';
            this.sortIndex = 3;
            this.pageNum = 0;
            this.fetchData();
        },
        async openBusinessDialog() {
            this.businessTypeObjs = ['全部', '人民币', '美元']
                .map(languageTranslation)
                .map((it, index) => {
                    return {
                        label: it,
                        value: index,
                    };
                });
            this.sortIndex = 4;
            this.businessFlag = true;
        },
        async fetchData() {
            let self = this;
            let sort = {};
            let cond = {};
            if (this.businessTypeIndex) {
                cond['businessType'] = this.businessTypeIndex;
            }
            let sortIndexObj = {
                // 热门
                0: () => {
                    sort = {
                        hot: -1,
                        open: -1,
                        _vpInRmb: -1,
                    };
                },
                // 市值倒序
                1: () => {
                    sort = {
                        _vpInRmb: -1,
                    };
                },
                // 市值升序
                2: () => {
                    sort = {
                        _vpInRmb: 1,
                    };
                },
                3: () => {},
                4: () => {},
            };
            sortIndexObj[this.sortIndex]();

            // 收藏
            if (this.menuIndex == 1) {
                if (!userInstance.user) {
                    this.data = [];
                    return defaultbus.$emit('toggle-login');
                }

                let data = (await HttpClient.post(
                    '/company/fetch/collect/list',
                    {
                        sorts: sort,
                        businessTypeIndex: this.businessTypeIndex,
                        companyTagIdMulti: this.companyTagIdMulti,
                    },
                )).collects;

                this.data = data.map(it => {
                    it.collect = true;
                    return it;
                });

                return;
            }
            // 全部
            if (this.menuIndex == -1) {
            }
            // 可交易
            if (this.menuIndex == 0) {
                cond.open = true;
                sort.open = -1;
            }

            if (this.sortIndex != 3) {
                if (this.$refs.available) {
                    this.$refs.available.createtagMap();
                }
                this.tags = [];
                this.companyTagIdMulti = [];
                this.companyTagsNameMulti = [];
            }
            if (this.sortIndex != 4) {
                this.businessTypeIndex = 0;
                this.businessTypeLabel = '全部';
                this.businessTypeObjs = {
                    label: '全部',
                    value: 0,
                };
                this.businessFlag = false;
            }

            this.isLoading = true;

            let res = await HttpClient.post('/company/list', {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                kw: this.kw,
                sort,
                cond,
                companyTagIdMulti: this.companyTagIdMulti,
                collectIds: this.collectIds,
            });

            this.isLoading = false;
            if (this.pageNum == 0) {
                this.data = [];
                setScrollTop(0);
            }
            this.data = [...this.data, ...res.companies];

            this.totalData = res.count;
        },
        toMy() {
            if (!userInstance.user) {
                return defaultbus.$emit('toggle-login');
            }
            if (!this.checklogin()) return;

            this.$router.push({
                path: `${this.en}/main/my?active=2`,
            });
        },
        async collectAction(item) {
            //
            if (!this.checklogin()) return;
            await HttpClient.post('/company/collect', {
                company: item._id,
                collect: !item.collect,
            });
            this.$set(item, 'collect', !item.collect);
            if (item.collect) {
                M.toast({
                    html: languageTranslation('收藏成功'),
                });
            }
            this.fetchData();
        },
        initDropHandler() {
            $('.dropdown-button').dropdown({
                inDuration: 300,
                outDuration: 225,
                constrain_width: false, // Does not change width of dropdown to that of the activator
                hover: true, // Activate on hover
                gutter: 0, // Spacing from edge
                belowOrigin: false, // Displays dropdown below the button
                alignment: 'left', // Displays dropdown with edge aligned to the left of button
            });
        },
    },
};
</script>

<style scoped lang="less">
@import '../assets/head-item.less';
.waves-effect {
    display: flex;
    justify-content: center;
    align-items: center;
    .companyTagSpan {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.business-type-list {
    position: absolute;
    bottom: -110px;
    font-size: 10px;
    left: 119px;
    background-color: #fff;
    z-index: 999;
    display: flex;
    width: 150px;
    flex-direction: column;
    align-items: center;
    .business-type-box {
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80%;
        padding: 10px 0;
        border-bottom: 1px solid rgba(160, 160, 160, 0.2);
        color: #333;
    }
}
.click-develop-img {
    width: 15px;
    height: 5px;
}
.addIcon {
    position: relative;
    left: -1px;
}
.page-company {
    padding-top: 30px;
    .loading {
        @keyframes rotate-loading {
            to {
                transform: rotate(360deg);
            }
        }
        i {
            color: #bc242b;
            font-size: 50px;
            animation: rotate-loading 0.7s linear infinite;
        }
    }
    .left-menu {
        width: 300px;
        // float: left;
        position: fixed;
        .sort {
            margin-top: 30px;
        }
        .menu-list {
            border-radius: 5px;
        }
    }
    .right-content {
        float: left;
        width: 870px;
        margin-left: 330px;
        .way {
            position: fixed;
            height: 50px;
            width: 100px;
            right: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
            i {
                font-size: 30px;
                cursor: pointer;
                transform-origin: 50% 50%;
                transition: all ease 0.5s;
            }
            @keyframes check-anim {
                from {
                    transform: scale(0);
                }
                to {
                    transform: scale(1);
                }
            }
            .check1 {
                animation: check-anim ease 0.6s;
                color: #bc242b;
            }
        }
        @media only screen and (max-width: 1300px) {
            .way {
                display: none !important;
            }
        }
        .company {
            width: 100%;
            display: block;
            position: relative;
        }
        .grid-item {
            width: 270px;
            float: left;
            margin-right: 30px;
            margin-bottom: 30px;
            padding-bottom: 30px;
            border-radius: 5px;
            .hot {
                position: absolute;
                top: 0px;
                right: 0px;
                width: 50px;
            }
            .content {
                border-bottom: 1px solid rgba(160, 160, 160, 0.2);
                text-align: center;
                padding: 30px 0 30px 0;
                position: relative;
                img {
                    width: 60px;
                    height: 60px;
                }
                .name {
                    font-size: 13px;
                    color: #757575;
                }
                .guzhi {
                    margin-top: 5px;
                    font-size: 11px;
                    span {
                        color: #ff9100;
                    }
                }
                > a {
                    position: absolute;
                    bottom: 0;
                    transform: translateY(50%);
                    right: 20px;
                }
                > a.wait-collect {
                    background: white !important;
                    box-shadow: none;
                    border: 1px solid #1dace8;
                    i {
                        color: #1dace8 !important;
                    }
                }
            }
            .txt {
                font-size: 14px;
                line-height: 21px;
                height: 105px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                padding: 0 10px;
                margin: 30px 0 10px 0;
                word-break: break-all;
                text-align: justify;
            }
            .kjy {
                font-size: 11px;
                font-weight: bold;
                span {
                    color: #00b0ff;
                }
            }
        }
        .grid-item:nth-of-type(3n) {
            margin-right: 0;
        }
        .line-item {
            width: 100%;
            height: 170px;
            margin: 0 0 30px 0;
            .content {
                margin-left: 30px;
                float: left;
                border-bottom: 0;
                min-width: 100px;
                > a {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: -70px;
                }
            }
            .txt,
            .jyy {
                margin-left: 230px;
                margin-right: 30px;
            }
            .txt {
                margin-top: 20px;
            }
        }
    }
    @media screen and (min-width: 960px) and (max-width: 1200px) {
        .right-content {
            width: 750px;
            .grid-item:nth-of-type(3n) {
                margin-right: 30px;
            }
            .grid-item {
                .content {
                    text-align: center;
                    padding: 10px 0 10px 0;
                    position: relative;
                    img {
                        width: 50px;
                        height: 50px;
                    }
                    .name {
                        font-size: 13px;
                        color: #757575;
                    }
                    .guzhi {
                        margin-top: 5px;
                        font-size: 11px;
                        span {
                            color: #ff9100;
                        }
                    }
                }
                .txt {
                    height: 65px;
                    -webkit-line-clamp: 3;
                    margin: 30px 0 0px 0;
                }
            }
        }
    }
}

.needView {
    .needView-top {
        margin-top: 20px;
        height: 80px;
        .name {
            position: relative;
            left: 55px;
            top: -50px;
            font-weight: 600;
        }
        img {
            height: 50px;
            position: relative;
            left: -90px;
        }
        .gz {
            position: relative;
            left: -10px;
            top: -20px;
            font-size: 10px;
            color: #666;
            font-size: 500;
        }
        .tradeBtn {
            margin-top: -10px;
            .BtnStyle {
                height: 30px;
                width: 95px;
                border-radius: 2px;
                span {
                    color: #fff;
                    font-size: 10px;
                    line-height: 30px;
                }
            }
            .sellBtn {
                background-color: rgb(86, 186, 50);
            }
            .buyBtn {
                background-color: rgb(186, 38, 48);
            }
        }
        border-bottom: 1px solid rgba(236, 236, 236, 1);
    }
    .needView-bottom {
        height: 80px;

        .trade-box {
            width: 270px;

            background-color: aquamarine;
            .trade-layout {
                float: left;
                margin-top: 30px;
                font-size: 12px;
                width: 90px;
                span {
                    display: block;
                }
                .label {
                    color: #666;
                }
                .trade-type {
                    font-size: 15px;
                    font-weight: 600;
                    color: #000;
                }
                .trade-number {
                    color: #ea3c3e;
                    font-size: 15px;
                    font-weight: 900;
                }
            }
        }
    }
}
</style>

function newFunction() {
  return this.ceshi('独角汇');
}
